let isModalOpen = false;

const errorModalTemplate = `
<dialog class="cui-modal__native" id="error-dialog">
    <div class="cui cui-modal engine-error-modal">
        <div class="cui-modal__dialog">
            <div class="cui-modal__content -size--medium -with--scroll">
                <div class="cui modal-wrapper">
                    <div class="cui-modal__header-parent">
                        <div class="cui-modal__header">
                            <div class="cui-modal__header-wrapper">
                                <div class="cui-modal__header-titles animate-show">
                                    <h2 class="cui-modal__header-label cui-heading-l">
                                        We couldn't load parts of the page
                                    </h2>
                                    <div class="cui-modal__header-subtitle"></div>
                                </div>
                                <i class="modal-close-icon cui-icon-close" id="close-modal-icon"></i>
                            </div>
                        </div>
                        <div class="cui-modal__header-content"></div>
                    </div>
                    <div class="cui-modal__body">
                        <div class="modal-container">
                            <p style="margin-bottom: 2.5rem;">
                                There was a technical problem that prevented some interface elements from loading. 
                                Please try reloading the page.
                            </p>
                        </div>
                    </div>
                    <div class="cui-modal__footer">
                        <button id="reload-page-modal-button" autofocus type="button" class="cui-button -type--primary" onClick="window.location.reload();">
                            Reload page
                        </button>
                        <button id="close-modal-button" type="submit" class="cui-button -type--secondary -size--medium -mode--light">
                            Continue without reloading
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </dialog>
`;

export function showErrorModal(): void {
  if (isModalOpen) return;
  isModalOpen = true;

  const dialog = addModalTemplate(errorModalTemplate);
  setupDialog(dialog);
}

function setupDialog(dialog) {
  document.body.appendChild(dialog);
  setupCloseModalIcon(dialog);
  dialog.addEventListener("close", () => {
    dialog.remove();
    isModalOpen = false;
  });
  dialog.querySelector("#close-modal-button").addEventListener("click", () => {
    dialog.close();
  });
  dialog.showModal();
}

function addModalTemplate(errorModalTemplate: string) {
  document.body.insertAdjacentHTML("beforeend", errorModalTemplate);
  return document.getElementById("error-dialog") as HTMLDialogElement;
}

function setupCloseModalIcon(dialog: HTMLDialogElement) {
  const closeIcon = document.getElementById("close-modal-icon");
  closeIcon?.addEventListener("click", () => {
    dialog.close();
  });
}
